import * as React from "react";

import type { TooltipState } from "@fluentui/react-components";
import {
  useTooltipStyles_unstable,
  renderTooltip_unstable,
} from "@fluentui/react-components";
import type { AppTooltipProps } from "./AppTooltip.types";
import { useAppTooltip } from "./useAppTooltip";

export const AppTooltip: React.FC<AppTooltipProps> = React.memo(
  React.forwardRef<HTMLDivElement, AppTooltipProps>((props, _ref) => {
    const [visible, setVisible] = React.useState(props.tooltipVisible || false);
    const state = useAppTooltip(props, visible, setVisible);
    React.useEffect(() => {
      if (props.tooltipVisible !== undefined) {
        setVisible(props.tooltipVisible);
      }
    }, [props.tooltipVisible]);

    const dismissTooltip = (): void => {
      setVisible(false);
    };
    React.useEffect((): (() => void) => {
      window.addEventListener("keydown", dismissTooltip);
      window.addEventListener("click", dismissTooltip);
      return (): void => {
        window.removeEventListener("keydown", dismissTooltip);
        window.removeEventListener("click", dismissTooltip);
      };
    }, []);

    useTooltipStyles_unstable(state as TooltipState);
    return renderTooltip_unstable(state as TooltipState);
  })
);
